import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  withStyles,
} from '@material-ui/core';

import {
  Field,
  getFormValues,
} from 'redux-form';

import {renderSelect, renderTextField} from '../../../../atoms/CustomPart';
import {MiniHeaderCell} from '../atoms/tableCells';

import * as validateRule from '../../../../validateRule';

const styles = (theme) => ({
});

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

const OrderInfoTable = (props) => {
  const {
    isManuallyAdded,
    isAdmin,
    readOnly,
    zgsyoComboItems,
    kyogaTypeComboItems,

    values,
    classes,
  } = props;

  // 一覧に電柱が1件でも登録されている場合、事業所を変更できないようにする
  // (電柱追加後に事業所を変更すると、既存電柱との事業所不整合が生じるため)
  const hasTargetPoles = (values?.DrSideKoziTargetPoles__r?.length ?? 0) > 0;

  return (
    <>
      {!isManuallyAdded && (
        <TableContainer component={Paper}>
          <Table size="small" sx={{tableLayout: 'fixed', width: '100%'}}>
            <TableBody>
              <TableRow>
                <MiniHeaderCell width="30%">申込番号</MiniHeaderCell>
                <TableCell>{values?.Order__r?.OrderNo__c}</TableCell>
              </TableRow>

              <TableRow>
                <MiniHeaderCell>申込共架事業者</MiniHeaderCell>
                <TableCell>{values?.OrderKyogaZgsya__c}</TableCell>
              </TableRow>

              <TableRow>
                <MiniHeaderCell>共架種別</MiniHeaderCell>
                <TableCell>{values?.KyogaType}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Paper style={{marginTop: '6px', padding: '10px'}}>
        <Grid
          key="search-1"
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          {isManuallyAdded && (
            <>
              <Grid key="orderInfo-KyogaGigyosya" item xs={12}>
                <Field
                  name="OrderKyogaZgsya__c"
                  className={classes.fields}
                  label="申込共架事業者"
                  component={renderTextField}
                  fullWidth
                  type="text"
                  required={true}
                  disabled={readOnly}
                  inputProps={{
                    maxLength: 50,
                  }}
                  validate={[
                    validateRule.required,
                    validateRule.maxLength(50),
                    validateRule.fullWidth,
                  ]}
                />
              </Grid>
              <Grid key="orderInfo-KyogaType" item xs={12}>
                <Field
                  name="KyogaType__c"
                  className={classes.fields}
                  label="共架種別"
                  component={renderSelect}
                  fullWidth
                  type="text"
                  required={true}
                  disabled={readOnly}
                  validate={[
                    validateRule.required,
                  ]}
                >
                  {kyogaTypeComboItems}
                </Field>
              </Grid>
            </>
          )}

          <Grid key="orderInfo-kijunbi" item xs={12} sm={6}>
            <Field
              name="CostKizyunDate__c"
              className={classes.fields}
              label="算定基準日"
              component={renderTextField}
              fullWidth
              type="date"
              required={true}
              disabled={!isAdmin || readOnly}
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.required,
              ]}
            />
          </Grid>

          <Grid key="search-Zgsyo" item xs={12} sm={6}>
            <Field
              name="NWZgsyo__r.Code__c"
              className={classes.fields}
              component={renderSelect}
              label="事業所"
              fullWidth
              required={true}
              disabled={!isAdmin || readOnly || hasTargetPoles}
              validate={[
                validateRule.required,
              ]}
            >
              {zgsyoComboItems}
            </Field>
          </Grid>

          <Grid key="orderInfo-tanto" item xs={12} sm={6}>
            <Field
              name="GaisanDesignTanto__c"
              className={classes.fields}
              label="設計担当者"
              component={renderTextField}
              fullWidth
              type="text"
              required={true}
              disabled={readOnly}
              inputProps={{
                maxLength: 20,
              }}
              validate={[
                validateRule.required,
                validateRule.maxLength(20),
              ]}
            />
          </Grid>

          <Grid key="orderInfo-tel" item xs={12} sm={6}>
            <Field
              name="Tel__c"
              className={classes.fields}
              label="電話番号"
              component={renderTextField}
              fullWidth
              type="text"
              required={true}
              disabled={readOnly}
              inputProps={{
                maxLength: 11,
              }}
              validate={[
                validateRule.required,
                validateRule.number,
                validateRule.minLength(10),
                validateRule.maxLength(11),
              ]}
            />
          </Grid>

          <Grid key="orderInfo-memo" item xs={12}>
            <Field
              name="Memo__c"
              className={classes.fields}
              label="メモ欄"
              component={renderTextField}
              fullWidth
              type="text"
              multiline
              rows={2}
              required={false}
              disabled={readOnly}
              inputProps={{
                maxLength: 255,
              }}
              validate={[
                validateRule.maxLength(255),
              ]}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

OrderInfoTable.propTypes = {
  isManuallyAdded: PropTypes.bool,
  isAdmin: PropTypes.bool,
  readOnly: PropTypes.bool,
  zgsyoComboItems: PropTypes.array,
  kyogaTypeComboItems: PropTypes.array,
  values: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

const FORM_NAME = 'DrSideKoziCostDetail';

const ConnectedValues = connect((state) => ({
  values: getFormValues(FORM_NAME)(state),
}))(OrderInfoTable);

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(ConnectedValues),
);
